import { NetworkSlug } from 'domain/types';

import { blockExplorers } from './constants';

export function makeTxUrl(hash: string, network: NetworkSlug) {
  return `https://${blockExplorers[network] || blockExplorers.default}/tx/${hash}`;
}
